import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moly',
  templateUrl: './moly.component.html',
  styleUrls: ['./moly.component.scss']
})
export class MolyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
